import Send from '@/assets/icons/Send';
import LoadingIndicator from '@/features/ai-chat/components/AskGXDrawer/LoadingIndicator/LoadingIndicator';
import { Box } from '@/shared/ui/layout/Box';
import Typography from '@/shared/ui/typography/Text';

import { useNoMessagesScreen } from './useNoMessagesScreen';

const NoMessagesScreen = ({
  prompts = [
    'What data have you launched recently?',
    'Give me an overview of your US Nat Gas data',
    'What was the Eurobob price yesterday?',
    'Summarise the dynamics on Dated Brent',
    'How do carbon prices compare across projects by quality?'
  ]
}: {
  prompts?: string[];
}) => {
  const { sendMessage } = useNoMessagesScreen();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: 'auto'
      }}
    >
      <Typography
        component='div'
        sx={{
          color: 'common.white',
          fontFamily: 'Cairo',
          fontSize: '32px',
          fontStyle: 'normal',
          fontWeight: 500,
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          padding: '10px'
        }}
      >
        <LoadingIndicator animate={false} />
        What data can I get?
      </Typography>
      <Typography sx={{ fontSize: '20px', mt: '16px' }}>
        Here are some things you can try
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          mt: '16px'
        }}
      >
        {prompts.map(prompt => (
          <Box
            key={prompt}
            sx={{
              width: '420px',
              height: '50px',
              padding: '12px 16px',
              backgroundColor: 'gx.actionBarButtonTile',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer'
            }}
            onClick={() => {
              sendMessage(prompt);
            }}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{prompt}</Typography>
            <Send sx={{ fontSize: '24px' }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NoMessagesScreen;
